export default __webpack_public_path__ + "static/media/owerri-terminal.a25f2eb9.png";